/**
 * This is a list of constants for global events, right now it's only used by global event bus,
 * but it's not limit to it.
 */
export class GlobalEvents {
  /** SSP application */
  public static readonly validateTicket: string = 'sspValidateTicket';
  public static readonly submitTicket: string = 'sspSubmitTicket';
  public static readonly selectedDevice: string = 'sspSelectedDevice';
  public static readonly selectedTicket: string = 'sspSelectedTicket';
}
